<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<form action="#">
  <div class="text-center border-bottom mb-3">
    <h5 class="mb-1">Forgot Password</h5>
    <p>Reset Your Password</p>
  </div>
  <div class="mb-4">
    <label class="form-label">Email</label>
    <div class="input-icon">
      <span class="input-icon-addon">
        <i class="isax isax-message"></i>
      </span>
      <input type="email" class="form-control form-control-lg" [formControl]="email" placeholder="Enter Email">
    </div>
  </div>

  <ng-container *ngIf="otpData">
    <div [formGroup]="otpForm">
      <div class="mb-2">
        <label class="form-label">OTP</label>
        <div class="input-icon">
          <span class="input-icon-addon">
            <i class="isax isax-message"></i>
          </span>
          <input type="text" class="form-control form-control-lg" formControlName="otpCode" placeholder="Enter OTP">
        </div>

        <div class="d-flex justify-content-between align-items-center mt-1">
          <p class="fs-12 mb-0 message">OTP has been sent to you mail. Please check your inbox.</p>
          <p class="text-decoration-underline text-primary fs-12"><a class="pe-auto" (click)="resendOtp()">Resend OTP</a></p>
        </div>


      </div>

      <div class="mb-4">
        <label class="form-label">New Password</label>
        <div class="input-icon">
          <span class="input-icon-addon">
            <i class="isax isax-message"></i>
          </span>
          <input type="password" class="form-control form-control-lg" formControlName="newPassword" placeholder="Enter New Password">
        </div>
      </div>

      <div class="mb-4">
        <label class="form-label">Confirm Password</label>
        <div class="input-icon">
          <span class="input-icon-addon">
            <i class="isax isax-message"></i>
          </span>
          <input type="password" class="form-control form-control-lg" formControlName="confirmPassword" placeholder="Confirm New Password">
        </div>
      </div>
    </div>

    <div *ngIf="otpForm.errors && otpForm.errors['passwordMismatch'] && (otpForm.get('confirmPassword')?.touched || otpForm.get('confirmPassword')?.dirty)" class="text-danger fs-13 mt-1">
      Passwords do not match.
    </div>
  </ng-container>

  <p class="fs-12 text-danger">{{ errorMessage }}</p>

  <div class="mb-3">
    <div class="row" *ngIf="otpData; else noOtpData">
      <div class="col-6">
        <button type="button" class="btn btn-xl btn-primary d-flex align-items-center justify-content-center w-100"
          (click)="changeEmail()">
          <i  class="isax isax-arrow-left-3 ms-2"></i>
          Change Email
        </button>
      </div>
      <div class="col-6">
        <button type="button" class="btn btn-xl btn-primary d-flex align-items-center justify-content-center w-100"
          (click)="resetPassword()">
          Verify <i class="isax isax-arrow-right-3 ms-2"></i>
        </button>
      </div>
    </div>

    <ng-template #noOtpData>
      <button type="button" class="btn btn-xl btn-primary d-flex align-items-center justify-content-center w-100"
        (click)="forgotPassword()">Send OTP<i
          class="isax isax-arrow-right-3 ms-2"></i></button>
    </ng-template>
  </div>
  <div class="d-flex justify-content-center">
    <p class="fs-14">Remember Password ? <a href="javascript:void(0);" class="link-primary fw-medium"
        (click)="signIn()">Sign In</a></p>
  </div>
</form>
